import axios from "axios";
import { API } from "../constants/api";
import {
  axiosPostWithToken,
  axiosGetWithToken,
  axiosPut,
} from "../services/apiServices";
import { ERROR_ALERT, SUCCESS_ALERT } from "./commonAction";
import { submitKycRequest } from "../common/SelectFields";

export const MP_PROJECT_LAUNCH_LIST = "MP_PROJECT_LAUNCH_LIST";
export const MP_PROJECT_LAUNCH_LOADER = "MP_PROJECT_LAUNCH_LOADER";
export const MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE =
  "MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE";
export const MP_CHANGE_CURRENT_PROJECTLAUNCH_PAGE =
  "MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE";
export const MP_SEARCH_JOBS = "MP_SEARCH_JOBS";
export const MP_CHANGE_CURRENT_PROJECT_PAGE = "MP_CHANGE_CURRENT_PROJECT_PAGE";
export const MP_SET_PROJECT_ITEMS_PER_PAGE = "MP_SET_PROJECT_ITEMS_PER_PAGE";
export const MP_PROJECT_STATUS_FILTER = "MP_PROJECT_STATUS_FILTER";

export const MP_LAUNCH_NOTES_LOADER = "MP_LAUNCH_NOTES_LOADER";
export const MP_LAUNCH_NOTES_LIST_SUCCESS = "MP_LAUNCH_NOTES_LIST_SUCCESS";
export const MP_LAUNCH_NOTES_LIST_FAIL = "MP_LAUNCH_NOTES_LIST_FAIL";
export const MP_LAUNCH_UPDATE_SUCCESS = "MP_LAUNCH_UPDATE_SUCCESS";

export const MP_LAUNCH_OFFER_LOADER = "MP_LAUNCH_OFFER_LOADER";
export const MP_LAUNCH_OFFER_LIST_SUCCESS = "MP_LAUNCH_OFFER_LIST_SUCCESS";
export const MP_LAUNCH_OFFER_LIST_FAIL = "MP_LAUNCH_OFFER_LIST_FAIL";
export const MP_LAUNCH_DETAILS = "MP_LAUNCH_DETAILS";
export const CHANGE_MP_LAUNCH_TAB = "CHANGE_MP_LAUNCH_TAB";
export const SET_MP_LAUNCH_DATE_FILTER = "SET_MP_LAUNCH_DATE_FILTER";
export const CLEAR_MP_LAUNCH_DATE_FILTER = "CLEAR_MP_LAUNCH_DATE_FILTER";

//RENEWALS
export const MP_RENEWAL_LOADER = "MP_RENEWAL_LOADER";
export const MP_RENEWAL_LIST_SUCCESS = "MP_RENEWAL_LIST_SUCCESS";
export const MP_RENEWAL_LIST_FAIL = "MP_RENEWAL_LIST_FAIL";

//PAYMENTS for FINANCE
export const MP_FINANCE_LOADER = "MP_FINANCE_LOADER";
export const MP_FINANCE_LIST_SUCCESS = "MP_FINANCE_LIST_SUCCESS";
export const MP_FINANCE_LIST_FAIL = "MP_FINANCE_LIST_FAIL";

export const ASSET_URL = "ASSET_URL";
export const BULK_UPLOAD_PAYMENTS = "BULK_UPLOAD_PAYMENTS";
export const VIEW_AGREEMENT = "VIEW_AGREEMENT";
export const SET_AGREEMENT_TYPE = "SET_AGREEMENT_TYPE";
export const OFFERS_PER_PAGE = "OFFERS_PER_PAGE";
export const OFFERS_CURRENT_PROJECT_PAGE = "OFFERS_CURRENT_PROJECT_PAGE";
export const MP_SEARCH_OFFERS = "MP_SEARCH_OFFERS";
export const COMPANY_LEGAL_INFO = "COMPANY_LEGAL_INFO";
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const CONSULTANT_LEGAL_INFO = "CONSULTANT_LEGAL_INFO";
export const CUSTOM_CLIENT_LEGAL_INFO = "CUSTOM_CLIENT_LEGAL_INFO";
export const GET_BILLING_CONFIG = "GET_BILLING_CONFIG";
export const GET_STATE_LIST = "GET_STATE_LIST";
export const GET_CITY_LIST = "GET_CITY_LIST";

export const getMPLaunchList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const {
      mpLaunchCurrentPage,
      mpLaunchSearchText,
      mpLaunchStatusFliter,
      dateFilters,
    } = getState().mpLaunch;

    const bodyData = {
      page_no: mpLaunchCurrentPage,
    };

    if (mpLaunchSearchText) {
      bodyData.search = mpLaunchSearchText;
    }

    // Status handling (your existing logic preserved)
    if (mpLaunchStatusFliter.length === 1) {
      bodyData.status = String(mpLaunchStatusFliter[0]);
    } else if (mpLaunchStatusFliter.length > 1) {
      bodyData.statusus = mpLaunchStatusFliter.map(String);
    }

    //  Add ALL applied date filters dynamically
    Object.entries(dateFilters).forEach(([key, value]) => {
      if (value?.length === 2) {
        bodyData[key] = value;
      }
    });

    axiosPostWithToken(API.MP_LAUNCH_LIST, bodyData, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: MP_PROJECT_LAUNCH_LIST,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err?.response?.data || "Something went wrong.",
        });
      });
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: MP_SET_PROJECTLAUNCH_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: MP_CHANGE_CURRENT_PROJECT_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: MP_SEARCH_JOBS,
      payload: value,
    });
  };
};

export const editNotes = (id, data, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosPostWithToken(`${API.EDIT_PROJECT_NOTES}/${id}`, data, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: MP_PROJECT_LAUNCH_LOADER,
          });
          refresh();
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Notes updated Successfully",
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res.data.data.message ||
              "Something went wrong. Error updating User.",
          });
        }
      },
    );
  };
};

export const setLaunchStatusFliter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_STATUS_FILTER,
      payload: value,
    });
  };
};

export const exportProjectData = (fromDate, toDate) => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_PROJECT_LAUNCH_LOADER });

    const token = getState().auth.token;
    const pageNumber = getState().mpLaunch.mpLaunchCurrentPage;
    const searchText = getState().mpLaunch.mpLaunchSearchText;
    const statusus = getState().mpLaunch.mpLaunchStatusFliter;

    const bodyData = {
      search: searchText,
      page_no: pageNumber,
      from: fromDate,
      to: toDate,
    };

    if (statusus.length === 1) {
      bodyData.status = String(statusus[0]);
    } else if (statusus.length > 1) {
      bodyData.statusus = statusus.map(String);
    }

    const apiUrl = `${API.MP_LAUNCH_LIST_EXPORT}`;

    axiosPostWithToken(apiUrl, bodyData, token, {
      responseType: "blob",
    })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "mp-data.csv");
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload: err?.response?.data || "Something went wrong.",
        });
      });
  };
};
// Fetch Launch Notes List
export const getLaunchNotes = (launchId) => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_LAUNCH_NOTES_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.MP_LAUNCH_NOTE_LIST}/${launchId}`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const data = res?.data?.data;

        if (statusCode === 200 && Array.isArray(data)) {
          dispatch({
            type: MP_LAUNCH_NOTES_LIST_SUCCESS,
            payload: data,
          });
        } else if (statusCode === 404) {
          dispatch({
            type: MP_LAUNCH_NOTES_LIST_SUCCESS,
            payload: [],
          });

          console.info(" No notes found for this launch.");
        } else {
          dispatch({ type: MP_LAUNCH_NOTES_LIST_FAIL });
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load notes.",
          });
        }
      })
      .catch((err) => {
        dispatch({ type: MP_LAUNCH_NOTES_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching notes.",
        });
      });
  };
};

//  Add New Note
export const addLaunchNote = (launchId, note, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_LAUNCH_CREATE_NOTE}/${launchId}/`;

    const bodyData = {
      notes: note,
    };

    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
          });

          dispatch(getLaunchNotes(launchId));
          if (callback) callback(); // close dialog etc.
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.message || "Failed to add note.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while adding note.",
        });
      });
  };
};
export const updateLaunchDetails = (launchId, data, callback) => {
  const payload = { ...data };

  // --- DATE FIELDS (must update when cleared) ---
  const dateFields = [
    "latest_start_date",
    "latest_sow_date",
    "termination_date",
    "tentative_end_date",
    "status",
  ];

  dateFields.forEach((field) => {
    // Convert empty string or undefined to null
    if (payload[field] === "" || payload[field] === undefined) {
      payload[field] = null;
    }
  });

  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_LAUNCH_LIST_UPDATE}/${launchId}`;

    axiosPostWithToken(apiUrl, payload, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({ type: MP_LAUNCH_UPDATE_SUCCESS });
          dispatch(getMPLaunchList());
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to update launch.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while updating launch.",
        });
      });
  };
};

//Offers
export const getOfferList = () => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_LAUNCH_OFFER_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.MP_OFFERS_LIST}`;
    const pageNumber = getState().mpLaunch.mpLaunchCurrentPage;
    const searchText = getState().mpLaunch.offersSearchText;

    // API expects POST body like this
    const bodyData = {
      search: "",
      page_no: pageNumber,
    };

    if (searchText) {
      bodyData.search = searchText;
    }

    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const apiData = res?.data?.data;

        if (statusCode === 200) {
          dispatch({
            type: MP_LAUNCH_OFFER_LIST_SUCCESS,
            payload: apiData,
          });
        } else if (statusCode === 404) {
          dispatch({
            type: MP_LAUNCH_OFFER_LIST_SUCCESS,
            payload: [],
          });
          console.info("No offers found.");
        }
      })
      .catch((err) => {
        dispatch({ type: MP_LAUNCH_OFFER_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching offers.",
        });
      });
  };
};
export const createLaunchOffer = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_OFFER_CREATE}/${launchId}/`;

    const bodyData = {
      offer: Number(data.offer),
      offer_end_date: data.offer_end_date,
      notes: data.notes?.trim() || "",
      offer_status: String(data.offer_status),
    };
    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Offer added successfully.",
          });
          dispatch(getMPLaunchList());
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to create offer.",
          });
        }
      })
      .catch((err) => {
        console.error("Offer Create Error:", err.response?.data || err.message);
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while adding offer.",
        });
      });
  };
};
//Update existing offer
export const updateLaunchOffer = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_OFFER_UPDATE}/${launchId}/`;

    const bodyData = {
      // offer: Number(data.offer),
      ...(data.offer_end_date && { offer_end_date: data.offer_end_date }),
      ...(data.notes?.trim() && { notes: data.notes.trim() }),
      ...(data.offer_status && { offer_status: String(data.offer_status) }),
    };

    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Offer updated successfully.",
          });
          dispatch(getMPLaunchList());
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to Update offer.",
          });
        }
      })
      .catch((err) => {
        console.error("Offer Update Error:", err.response?.data || err.message);
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while updating offer.",
        });
      });
  };
};
export const getRenewalList = (launchId) => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_RENEWAL_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.MP_RENEWALS_LIST}/${launchId}/`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const apiData = res?.data?.data || [];
        if (statusCode === 200 && Array.isArray(apiData)) {
          dispatch({
            type: MP_RENEWAL_LIST_SUCCESS,
            payload: apiData,
          });
        } else {
          dispatch({ type: MP_RENEWAL_LIST_FAIL });
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load renewals.",
          });
        }
      })
      .catch((err) => {
        dispatch({ type: MP_RENEWAL_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching renewals.",
        });
      });
  };
};
//Create a new renewal
export const createMPRenewal = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_RENEWALS_CREATE}/${launchId}/`;
    const bodyData = {
      date_of_renewal: data.date_of_renewal,
      renewal_period: data.renewal_period,
      new_client_pricing: data.new_client_pricing,
      new_candidate_pricing: data.new_candidate_pricing,
      new_job_hours: data.new_job_hours,
      status: data.status,
    };
    axiosPostWithToken(apiUrl, bodyData, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Renewal created successfully.",
          });
          dispatch(getRenewalList(launchId));
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              res?.data?.message ||
              res.data.data.message ||
              "Failed to create a renewal.",
          });
        }
      })
      .catch((err) => {
        console.error(
          "Renewal Create Error:",
          err.response?.data || err.message,
        );
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while creating a renewal.",
        });
      });
  };
};
//Update existing renewal
export const updateMPRenewal = (launchId, data, callback) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.MP_RENEWALS_UPDATE}/${launchId}/`;

    const bodyData = {
      ...(data.date_of_renewal && { date_of_renewal: data.date_of_renewal }),
      ...(data.renewal_period && { renewal_period: data.renewal_period }),
      ...(data.new_client_pricing && {
        new_client_pricing: data.new_client_pricing,
      }),
      ...(data.new_candidate_pricing && {
        new_candidate_pricing: data.new_candidate_pricing,
      }),
      ...(data.new_job_hours && { new_job_hours: data.new_job_hours }),
      ...(data.status && { status: data.status }),
    };

    try {
      const res = await axiosPut(apiUrl, bodyData, token);

      if (res?.data?.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Renewal updated successfully.",
        });

        // Optionally refresh parent list
        dispatch(getMPLaunchList?.());

        if (callback) callback(); // run callback AFTER the list refresh
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.message || "Failed to update renewal.",
        });
      }
    } catch (err) {
      console.error("Renewal Update Error:", err.response?.data || err.message);
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while updating the renewal.",
      });
    }
  };
};
//MP Launch Details
export const mpLaunchDetails = (id, disableLoader) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosGetWithToken(`${API.MP_LAUNCH_DETAILS}/${id}/`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: MP_LAUNCH_DETAILS,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const changeviewMPLaunchTab = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CHANGE_MP_LAUNCH_TAB,
      payload: id,
    });
  };
};

//Finance Details
//List of payments for MP Launch
export const getPaymentList = (launchId) => {
  return async (dispatch, getState) => {
    dispatch({ type: MP_FINANCE_LOADER });

    const token = getState().auth.token;
    const apiUrl = `${API.MP_FINANCE_LIST}/${launchId}/`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        const statusCode = res?.data?.status_code;
        const apiData = res?.data?.data || []; // direct array access
        if (statusCode === 200 && Array.isArray(apiData)) {
          dispatch({
            type: MP_FINANCE_LIST_SUCCESS,
            payload: apiData,
          });
        } else {
          dispatch({ type: MP_FINANCE_LIST_FAIL });
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to load payments.",
          });
        }
      })
      .catch((err) => {
        dispatch({ type: MP_FINANCE_LIST_FAIL });
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while fetching renewals.",
        });
      });
  };
};

//Create payment for MP Launch
export const createMPPayment = (launchId, data, launch,callback, ) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = launch === "project"
      ? `${API.ADD_PROJECT_PAYMENTS_LIST}${launchId}/`
      : `${API.MP_FINANCE_CREATE}/${launchId}/`;

    axiosPostWithToken(apiUrl, data, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Payment created successfully.",
          });
          if (callback) callback();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to create a payment.",
          });
        }
      })
      .catch((err) => {
        console.error(
          "Payment Create Error:",
          err.response?.data || err.message,
        );
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while creating a payment.",
        });
      });
  };
};

//Update payment for MP Launch
export const updateMPPayment = (paymentId, launchId, data,launch, callback, ) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = launch === "project"
      ? `${API.UPDATE_PROJECT_PAYMENTS_LIST}${paymentId}/`
      : `${API.MP_FINANCE_UPDATE}/${paymentId}/`;

    try {
      const res = await axiosPostWithToken(apiUrl, data, token);

      if (res?.data?.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Payment updated successfully.",
        });

        // Wait for renewal list to refresh before closing modal
        // await dispatch(getPaymentList(launchId));

        if (callback) callback(); // run callback AFTER the list refresh
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.message || "Failed to update Payment.",
        });
      }
    } catch (err) {
      console.error("Payment Update Error:", err.response?.data || err.message);
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while updating the Payment.",
      });
    }
  };
};

export const uploadPayment = (file) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(API.ASSET_UPLOAD, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status_code === 200) {
        const fileUrl = response.data.data.url;
        const payload = {
          file_url: fileUrl,
          file_name: file?.name,
        };

        dispatch({ type: ASSET_URL, payload: fileUrl });
        // return fileUrl
        const res = await axiosPostWithToken(
          API.UPLOAD_PAYMENTS,
          payload,
          token,
        );
        if (res.data.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "File uploaded successfully",
          });
        } else {
          dispatch({ type: ERROR_ALERT, payload: res?.data?.data?.message });
        }
      }
    } catch (error) {
      dispatch({
        type: ERROR_ALERT,
        payload: "An error occurred while uploading the file.",
      });
      throw error;
    }
  };
};
export const getBulkUploadPayments = (id, disableLoader) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosGetWithToken(`${API.UPLOAD_LIST}`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: BULK_UPLOAD_PAYMENTS,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res.data.data.message || "Something went wrong.",
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const uploadAgreement = (id, file, agreement) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("agreement_type", agreement);

      const res = await axiosPostWithToken(
        `${API.UPLOAD_AGREEMENT}${id}/upload-agreement/`,
        formData,
        token,
      );

      if (res.data.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "File uploaded successfully",
        });
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: res?.data?.data?.message,
        });
      }
    } catch (error) {
      dispatch({
        type: ERROR_ALERT,
        payload: "An error occurred while uploading the file.",
      });
      throw error;
    }
  };
};

export const viewAgreements = (id, agreement) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    axiosGetWithToken(`${API.VIEW_AGREEMENT}${id}/${agreement}`, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: VIEW_AGREEMENT,
            payload: res.data.data,
          });
        } else {
          dispatch({
            type: VIEW_AGREEMENT,
            payload: [], // clear if error
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: VIEW_AGREEMENT,
          payload: [], // clear on failure
        });
        console.log("Error:", error);
      });
  };
};
export const setAgreementType = (type) => ({
  type: SET_AGREEMENT_TYPE,
  payload: type,
});

export const createOffer = (data) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const apiUrl = `${API.CRETAE_OFFERS}`;

    axiosPostWithToken(apiUrl, data, token)
      .then((res) => {
        if (res?.data?.status_code === 200) {
          dispatch({
            type: SUCCESS_ALERT,
            payload: "Offer Created successfully.",
          });
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: res?.data?.message || "Failed to create offer.",
          });
        }
      })
      .catch((err) => {
        console.error("Offer Create Error:", err.response?.data || err.message);
        dispatch({
          type: ERROR_ALERT,
          payload:
            err?.response?.data?.message ||
            "Something went wrong while adding offer.",
        });
      });
  };
};

export const setItemsPerPageOffer = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: OFFERS_PER_PAGE,
      payload: value,
    });
  };
};

export const searchOffers = (value) => {
  return async (dispatch) => {
    dispatch({
      type: MP_PROJECT_LAUNCH_LOADER,
    });
    dispatch({
      type: MP_SEARCH_OFFERS,
      payload: value,
    });
  };
};

export const kYCDetails = (id, kyc, disableLoader) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const URL_MAP = {
      ClientProjectKYC: API.COMPANY_LEGAL_INFO,
      ConsultantKYC: API.CONSULTANT_LEGAL_INFO,
      CustomProjectKYC: API.GET_CUSTOM_KYC,
    };

    const ACTION_TYPE_MAP = {
      ClientProjectKYC: COMPANY_LEGAL_INFO,
      ConsultantKYC: CONSULTANT_LEGAL_INFO,
      CustomProjectKYC: CUSTOM_CLIENT_LEGAL_INFO,
    };

    const apiBase = URL_MAP[kyc] ?? API.COMPANY_LEGAL_INFO;
    const actionType = ACTION_TYPE_MAP[kyc] ?? COMPANY_LEGAL_INFO;
    const apiUrl = `${apiBase}/${id}/`;

    axiosGetWithToken(apiUrl, token)
      .then((res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: actionType,
            payload: res.data.data,
          });
        } else {
          console.log("Error fetching KYC details:", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (err && err.response && err.response.data) ||
            "Something went wrong.",
        });
      });
  };
};

export const addKycDetails = (Id, formData, callback, edit, kyc) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const clientApiUrl = edit
      ? `${API.UPDATE_COMPANY_LEGAL_INFO}/${Id}/`
      : `${API.CREATE_COMPANY_LEGAL_INFO}/${Id}/`;
    const customApiUrl = edit
      ? `${API.UPDATE_CUSTOM_KYC}/${Id}/`
      : `${API.CREATE_CUSTOM_KYC}/${Id}/`;

    const apiUrl = kyc === "ClientProjectKYC" ? clientApiUrl : customApiUrl;

    return submitKycRequest({
      apiUrl,
      formData,
      edit,
      token,
      dispatch,
      callback,
    });
  };
};

export const uploadLegalDoc = (file, type) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const formData = new FormData();

      formData.append("file", file);
      formData.append("user_type", type);

      const response = await axios.post(API.UPLOAD_LEGAL_DOC, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.status_code === 200) {
        const fileUrl = response.data.data.url;

        return fileUrl;
      }

      dispatch({
        type: ERROR_ALERT,
        payload: response?.data?.data?.message || "Invalid File Extension",
      });

      return null;
    } catch (error) {
      dispatch({
        type: ERROR_ALERT,
        payload:
          error?.data?.message || "An error occurred while uploading the file.",
      });

      throw error;
    }
  };
};

export const getCountryList = () => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const response = await axiosGetWithToken(API.COUNTRY_LIST, token);
      if (response.status === 200) {
        const countries = response?.data || [];

        dispatch({
          type: GET_COUNTRY_LIST,
          payload: countries,
        });
      }
    } catch (err) {
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while fetching country list.",
      });
    }
  };
};

const formatDate = (date = new Date()) => {
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const y = date.getFullYear();
  return `${d}-${m}-${y}`;
};

const getDocFilename = (docType, companydata) => {
  const clientName =
    companydata?.client_name || companydata?.company_name || "Client";
  const consultantName = companydata?.candidate_legal_name || "Consultant";
  const roleName = companydata?.role_name || "Role";
  const date = formatDate();

  switch (docType) {
    case "sow":
      return `SOW_${clientName}_${date} (${consultantName}- ${roleName})- (Indian clients- Other than Propertiorship).docx`;
    case "side_letter":
      return `Side Letter_${clientName}_${date} (${consultantName}- ${roleName}).docx`;
    case "msa":
      return `${clientName}_FlexiBees Master Flexi Staffing Agreement.docx`;
    default:
      return `${clientName}_contract-document.docx`;
  }
};

export const generateContractDoc = (companydata, docs) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    const payload = { documents: docs };

    try {
      const response = await axios.post(
        `${API.GENERATE_CONTRACT_DOC}${companydata?.id}/generate-contract-documents/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        },
      );

      const contentType = response.headers["content-type"] || "";
      const isZip = contentType.includes("zip");

      let filename;
      if (isZip) {
        filename = `${companydata?.company_name}_contract-documents.zip`;
      } else {
        // Single doc: use our own template since backend's header isn't exposed via CORS
        filename = getDocFilename(docs[0], companydata);
      }

      const blob = new Blob([response.data], { type: contentType });
      const fileUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileUrl);

      return fileUrl;
    } catch (error) {
      let message = "An error occurred while generating the document.";
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const parsed = JSON.parse(text);
          message = parsed?.data?.message || message;
        } catch (e) {}
      }
      dispatch({ type: ERROR_ALERT, payload: message });
      throw error;
    }
  };
};

export const getBillingConfig = () => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const response = await axiosGetWithToken(API.BILLING_CONFIG_LIST, token);
      if (response.status === 200) {
        const billingConfig = response?.data?.data?.message || [];

        dispatch({
          type: GET_BILLING_CONFIG,
          payload: billingConfig,
        });
      }
    } catch (err) {
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while fetching country list.",
      });
    }
  };
};

export const addBilling = (data) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;
    try {
      const res = await axiosPostWithToken(
        `${API.ADD_BILLING_CONFIG}/`,
        data,
        token,
      );

      if (res?.data?.status_code === 200) {
        dispatch({
          type: SUCCESS_ALERT,
          payload: "Billing Config updated successfully",
        });
        dispatch(getBillingConfig()); // refresh the config so the UI updates
        return true;
      }

      dispatch({
        type: ERROR_ALERT,
        payload:
          res?.data?.data?.message ||
          res?.data?.message ||
          "Something went wrong. Error updating Billing Config.",
      });
      return false;
    } catch (err) {
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong. Error updating Billing Config.",
      });
      return false;
    }
  };
};

export const getStateList = (id) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const response = await axiosGetWithToken(`${API.STATE_LIST}/${id}`, token);
      if (response.status === 200) {
        const stateList = response.data;

        dispatch({
          type: GET_STATE_LIST,
          payload: stateList,
        });
      }
    } catch (err) {
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while fetching country list.",
      });
    }
  };
};


export const getCityList = (id) => {
  return async (dispatch, getState) => {
    const token = getState().auth.token;

    try {
      const response = await axiosGetWithToken(`${API.CITY_LIST}/${id}`, token);
      if (response.status === 200) {
        const cityList = response?.data ;
        dispatch({
          type: GET_CITY_LIST,
          payload: cityList,
        });
      }
    } catch (err) {
      dispatch({
        type: ERROR_ALERT,
        payload:
          err?.response?.data?.message ||
          "Something went wrong while fetching country list.",
      });
    }
  };
};